import {apiClient} from 'core/apiClient';
import {OrganizationListRequest, OrganizationPaginationContent, ProfileRole} from 'types/profile';

const URL = '/service/legal-identities';

export async function fetchOrganizationList(
    params: OrganizationListRequest,
): Promise<OrganizationPaginationContent> {
    return (
        await apiClient.post<OrganizationPaginationContent>('service/legal-identities', params, {
            baseURL: '/api/v2',
        })
    ).data;
}

type UpdateParticipantRolesPayload = {
    legalIdentityId: string | number;
    body: {
        rolesToAdd?: ProfileRole[];
        rolesToDeactivate?: ProfileRole[];
    };
};
export async function updateParticipantRoles(payload: UpdateParticipantRolesPayload) {
    return apiClient.put(`${URL}/${payload.legalIdentityId}/roles`, payload.body);
}
